import React from "react";
import { Icon } from "../Icon/Icon";

export const SectionText = ({
  customClasses,
  iconName,
  hideTitle,
  titleLabel,
  hideText,
  textLabel,
  subtitle,
}) => {
  const _iconName = iconName && `--with-icon`;
  return (
    <section className={["section-text", customClasses, _iconName].join(" ")}>
      {hideTitle !== "yes" ? (
        <h1 className="title">{titleLabel}</h1>
      ) : (
        ""
      )}

      {iconName && <Icon setViewBow="yes" name={iconName} />}

      {hideText !== "yes" ? (
        <p className="text">{textLabel}</p>
      ) : (
        ""
      )}
      
      {subtitle && <span className="more-info">{subtitle}</span>}
    </section>
  );
};
